import { prepareSortedOptions } from '../../prepareOptions';
import {
  ADAPTIVE_LIGHTING,
  DAYTIME_RUNNING_LIGHTS,
  FOG_LAMP,
  HIGH_BEAM_ASSISTANT,
  LED_HEADLIGHTS,
  LIGHT_SENSOR,
  XENON_HEADLIGHTS,
  HAS_DIMMING_INTERIOR_MIRROR,
  HAS_HEATED_WIND_SHIELD,
} from './values';

export default prepareSortedOptions([
  {
    value: ADAPTIVE_LIGHTING,
    label: __('carDetails.equipmentGroups.headlights'),
  },
  {
    value: DAYTIME_RUNNING_LIGHTS,
    label: __('carDetails.equipmentGroups.daytimeRunningLights'),
  },
  {
    value: FOG_LAMP,
    label: __('carDetails.equipmentGroups.fogLight'),
  },
  {
    value: LED_HEADLIGHTS,
    label: __('carDetails.equipmentGroups.headlightLED'),
  },
  {
    value: LIGHT_SENSOR,
    label: __('carDetails.equipmentGroups.automaticHeadlightControl'),
  },

  {
    value: XENON_HEADLIGHTS,
    label: __('carDetails.equipmentGroups.xenonLights'),
  },
  {
    value: HIGH_BEAM_ASSISTANT,
    label: __('carDetails.equipmentGroups.highbeamAssistant'),
  },
  {
    value: HAS_DIMMING_INTERIOR_MIRROR,
    label: __('carDetails.features.hasDimmingInteriorMirror'),
  },
  {
    value: HAS_HEATED_WIND_SHIELD,
    label: __('carDetails.features.hasHeatedWindShield'),
  },
]);
